import React from 'react'
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import {Modal} from 'react-bootstrap';
import './styles/form_matching.scss';
import Match from './Match'
import MultipleAppointments from './MultipleAppointments';
import { apiFetch } from '../../utils';

/**
 * Handles creating the modal and iterating through the hash of matches to create match steps
 */

class MatchWizard extends React.Component {
  /**
   * propTypes
   * formUrl - A computed url used to get the match JSON
   * formId - the ID of the form we're matching
   * **/
  static propTypes = {
    formUrl: PropTypes.string,
    formId: PropTypes.string,
    formType: PropTypes.string,
  };

  /**
   * state variables
  * formType - String of the form class, either inquiry or application
  * matches - JSON Object containing the match data
  * relatedContacts - Array containing all related contacts
  * matchStep - A calculated variable used to indicate which step of the modal we are on
  * matchLength - A calculated variable indicating total number of steps in the modal
  * contactsToImport - a created Object we pass back to the form listing which contacts were/were not matched.
* */

  constructor(props) {
    super(props);
    this.onMatchSelect = this.onMatchSelect.bind(this);
    this.state = {
      matches: {},
      relatedContacts: {},
      matchLength: 0,
      matchStep: 0,
      contactsToImport: {},
      showModal: this.props.showModal,
      isValid: false,
      formType: this.props.formType,
      loaded: false,
      appointmentId: '',
      stepsChecked: {},
    }
  };

  componentDidMount () {
    return fetch(this.props.formUrl, { credentials: 'include' })
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({
          relatedContacts: JSON.parse(responseJson.related_contacts),
          matches: JSON.parse(responseJson.matches),
          matchLength: Object.keys(JSON.parse(responseJson.matches)).length - 1,
          isValid: Object.keys(JSON.parse(responseJson.matches)).length === 0,
          loaded: true,
          appointmentId: responseJson.appointment_id,
        })
      });
  }

  fetchAndSetAppointments = (contactId, matches, hasAppointments) => {
    apiFetch.get({}, `/appointments/search?contact_id=${contactId}`)
      .then(res => {
        if (res.appointments && res.appointments.length > 0) {
          matches['APPOINTMENTS'] = res.appointments
          const matchLength = hasAppointments ? this.state.matchLength : this.state.matchLength + 1;
          this.setState({
            matches: matches,
            matchLength: matchLength
          });
        }
        else {
          const matchLength = matches['APPOINTMENTS'] ? this.state.matchLength - 1 : this.state.matchLength
          delete matches['APPOINTMENTS']
          this.setState({
            matches: matches,
            matchLength: matchLength
          })
        }
      })
      .catch(err => console.error("An error has occurred", err))
  }

  onMatchSelect(event) {
    const contactsToImport = this.state.contactsToImport;
    contactsToImport[event.target.name] = event.target.value;
    const stepsChecked = this.state.stepsChecked;
    stepsChecked[this.state.matchStep] = 1;
    this.setState({contactsToImport, isValid: true, stepsChecked});
    this.setYear();

    if (event.target.name == 'CHILD') {
      const matches = { ...this.state.matches };
      const contactId = contactsToImport['CHILD']
      if (contactId && contactId != 0) {
        // Checking to see if we have previously selected a student contact with appointments.  If so don't add an additional match step.
        const hasAppointments = !!this.state.matches['APPOINTMENTS']
        this.fetchAndSetAppointments(contactId, matches, hasAppointments)
      }
      // Select create new contact after selecting a contact match
      else if (contactId == 0 && this.state.matches['APPOINTMENTS']) {
        delete matches['APPOINTMENTS']
        this.setState({
          matches: matches,
          matchLength: this.state.matchLength - 1
        })
      }
    }
  }

  setYear() {
    // Handles creating the YearMatch step if the form year is higher than matched contact's year

    if (this.state.contactsToImport['CHILD'] && this.state.matchStep === 0) {
      const contactId = this.state.contactsToImport['CHILD'];
      const formContactYear = this.state.matches['CHILD'][0]['apply_year_name'];
      let matchedContact = null;
      let matchedContactYear = null;
      Object.values(this.state.matches['CHILD']).map(function (value) {
        if (value['id'] === contactId) {
          matchedContact = value;
          matchedContactYear = value['apply_year_name'];
        }
      });
// If the form year is higher than matched contact's year and we are on the first step AND
// this data is not in the matches object ( was not already created)
      if (matchedContactYear != null && formContactYear > matchedContactYear && !this.state.matches['YEAR']) {
        const matches = this.state.matches;
        // Add a new match with year data to the matches object
        matches['YEAR'] = [this.state.matches['CHILD'][0], matchedContact];
        // And set matches in state to the new matches object (old matches + matches)
        this.setState({matches: matches, matchLength: this.state.matchLength + 1});
      } // If someone changes the match so the form year is not higher than the match year, we need to remove the year match
      else if (this.state.matchStep === 0 && this.state.matches['YEAR'] && (matchedContactYear === null || formContactYear <= matchedContactYear)) {
        const matches = this.state.matches;
        delete matches.YEAR;
        this.setState({matches: matches, matchLength: this.state.matchLength - 1});
      }
    }
  }

  nextMatch(number) {
    let nextStep = number + 1;
    // Every time we go to the next page, we make it invalid so a selection needs to be made
    this.setState({matchStep: nextStep, isValid: nextStep in this.state.stepsChecked, flashWarning: false});
  }

  lastMatch(number) {
    this.setState({matchStep: number - 1, isValid: true});
  }

  importForm() {
    const self = this;
    const token = $('meta[name="csrf-token"]').attr('content');
    $('#import-form-modal').html("<i class='fa fa-spinner fa-spin fa-2x'/></i>");
    fetch('/form_matching/import', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'X-CSRF-Token': token},
      credentials: 'include',
      body: JSON.stringify({
        contacts_to_import: this.state.contactsToImport,
        id: this.props.formId,
        form_type: this.props.formType
      })
    }).then(() => self.close());
  }

  close() {
    this.setState({showModal: false});
    ReactDOM.unmountComponentAtNode(document.getElementById("component"));
    window.location.reload(false);
  }

  exit() {
    this.setState({showModal: false});
    ReactDOM.unmountComponentAtNode(document.getElementById("component"));
  }

  render() {
    const matchStep = this.state.matchStep;
    const contactsToImport = this.state.contactsToImport;
    const matches = this.state.matches;
    const matchLength = this.state.matchLength;
    const modalId = matchLength != -1 ? "import-form-modal" : "import-form-modal-small";
    const modalBodyClass = matchLength != -1 ?  'modal-body' : 'small-modal-body';
    const spinner = this.state.loaded ?  'd-none' : 'fa fa-spinner fa-spin fa-2x' ;
    const loading = this.state.loaded ?  'd-none' : 'text-center';

    return (
      <Modal show={this.state.showModal} id={modalId} backdrop='static' keyboard={false}>
        <Modal.Header>
          <h1 className='modal-title'>Import Form - Step {matchStep + 1} of {matchLength > 0 ? matchLength + 1 : 1}</h1>
          <button disabled={false} className="btn-close" type="button" aria-label="Close"
                  onClick={() => this.exit()} />
        </Modal.Header>
        <Modal.Body className={modalBodyClass}>
            <div className={loading}><i className={spinner}></i> Loading matches, please wait...</div>
          {/*  If we have no matches, matchLength ends up -1 */}
          {matchLength != -1 ?
            <div>
              {Object.keys(matches).map(function (key) {
                const match = matches[key];
                return (
                  <MatchStep match={match}
                              number={Object.keys(matches).indexOf(key)} entity={key}
                              matchStep={matchStep} onMatchSelect={this.onMatchSelect} contactsToImport={contactsToImport}
                              formType={this.state.formType} relatedContacts={this.state.relatedContacts}
                              appointmentId={this.state.appointmentId}
                  />
                )
              }, this)}
            </div>

            : <h3> No matches found. Click import to import this form. </h3>}

        </Modal.Body>
        <Modal.Footer>
          {matchStep != 0 ?
            <button disabled={false} className="btn btn-light" type="submit"
                      onClick={() => this.lastMatch(matchStep)}> {"< Previous"}</button> : ''
          }
          {
            this.state.matchLength === matchStep || this.state.matchLength === -1 ?
              <button
                // Overriding isValid only if we have appointments matched to a student. If so and if we are on the last step, then we are valid.
                disabled={!this.state.isValid && (!matches?.APPOINTMENTS || this.state.matchLength !== matchStep)}
                className="btn btn-success" type="submit"
                onClick={() => this.importForm()}>
                Import
              </button>
              : <button disabled={!this.state.isValid} className="btn btn-primary" type="submit"
                onClick={() => this.nextMatch(matchStep)}>Next &gt;</button>
          }
          <button disabled={false} className="btn btn-light" type="button" style={{float: 'left'}}
                  onClick={() => this.exit()}>
            Cancel and Exit
          </button>

        </Modal.Footer>
      </Modal>
    )
  }
}

/**
 * Each match step consists one of entity from the form (contact or household) and the matches we have for that entity.
 * We only show one at a time, based on which step of the match we are on
 * The rest are in hidden divs
 */

class MatchStep extends React.Component {

  render() {
    // These are just passed on to Match
    const matchSelect = this.props.onMatchSelect;
    const contactsToImport = this.props.contactsToImport;
    const relatedContacts = this.props.relatedContacts;
    // This is an object containing the form contact and all the matches
    const match = this.props.match;
    const number = this.props.number;
    const entity = this.props.entity;
    // This just strips the number out of HOUSEHOLD
    const entityMatch = entity.replace(/\d+$/, "");
    const entityType = entityMatch === 'HOUSEHOLD' ? 'household' : 'contact';
    const numberOfMatches = Object.keys(match).length - 1;
    const formType = this.props.formType === 'inquiry' ? 'Inquiry' : 'Applicant';
    const shouldShow = number === this.props.matchStep ? true : false;
    const childName = entity == 'APPOINTMENTS' ? `${match[0]['contact_data']['first_name']} ${match[0]['contact_data']['last_name']}` : '';
    return (
      <div className={shouldShow ? "row" : "row d-none"}>
        {/*  Year matches are presented differently than any other matches,
        so we have different returns here based on what kind of match this is*/}
        {entityMatch != 'YEAR' ? entity == 'APPOINTMENTS' ?
          <div className="form-import-paragraph hint">
            <h1><b>{childName}</b> may have duplicate appointments booked.</h1>
            <br />
            <h3>We found possible duplicate appointments. You may contact the parent to confirm or cancel.</h3>
          </div>
         :
          <div className="form-import-paragraph hint">
            <h1>{entityType != 'household' ? <b>{match[0]['name']}</b> : "This address"} may already be in the
              system.</h1>
            <br></br>
            <h3> We found {numberOfMatches} possible duplicate {numberOfMatches > 1 ? "records" : "record"}. You can merge with an
              existing {entityType} or create a
              new {entityType} record.</h3>
            <p></p>
          </div>


          : <div className="form-import-paragraph hint">
            <h1>There is a term conflict with the selected merge.</h1>
            <br></br>
            <h3> This merge could advance the term of an existing student in the database. Please choose the correct active term for this contact.</h3>
            <br></br>
          </div>
          }
        {
          entity == 'APPOINTMENTS' ?
            <div>
              <MultipleAppointments appointments={match} onMatchSelect={matchSelect} entity={entity} appointmentId={this.props.appointmentId} />
            </div>
            :
            Object.keys(match).map(function (key) {
              return (
                <Match match={match[key]} entity={entity} onMatchSelect={matchSelect} contactsToImport={contactsToImport}
                  formType={formType} relatedContacts={relatedContacts} />
              )
            })
        }
        {/*  This helper text appears if we have code in the contactsToImport for this kind of entity
         where the id is not 0 (not a form contact) and it is not a household (ie, if a match is selected on screen)*/}
        {contactsToImport[entity] && contactsToImport[entity] != 0 && entityType != 'household' ?
          <div className="form-import-helper-text form-import-paragraph hint">
            <h1>What happens when contact records are merged?</h1>
            <br></br>
            <p>
              <i className="fa fa-file"/> <i className="fa fa-long-arrow-right"/> <i className="fa fa-user"/> The data
              from the form will be added to the existing contact record you selected.
              <br></br>
              <i className="fa fa-file-text"/> <i className="fa fa-chevron-right"/> <i className="fa fa-folder-open"/>
              Where there is conflicting data, the newer data from the form will overwrite the data on the record
              <br></br>
              <i className="fa fa-file"/> <i className="fa fa-long-arrow-left"/> <i className="fa fa-folder-open"/> <b>Except</b>,
              the contact will NOT be moved backwards in the workflow (.e.g the role "Inquiry" will not overwrite the
              role "Applicant") </p>
          </div>
          : ""
        }

        {entityMatch === 'YEAR' ?
          <div className="form-import-helper-text form-import-paragraph hint">
          <br/>
            <h1> What does changing the term affect? </h1>
          <br/>
              <i className="fa fa-user"/> The contact's record will always show the most recent term they exist in, even if one of their past statuses is later in the workflow. <br/>
              <i className="fa fa-user"/> For example, merging an Enrolled student with an Inquiry form for a later term would mean the system would treat the student as an active inquiry for the purposes
            of portal visibility and list pages for that term. <br/>
              <i className="fa fa-user"/> The history will always be maintained, so statuses for older years will always be searchable and visible in list pages for past terms.
            </div> : ""}
      </div>)
  }
}


export default MatchWizard;
